<template>
  <div>
    <!-- 验证手机号 -->
    <van-popup v-model="show" position="bottom" class="phone_pop">
      <h2>请进行手机登录<img src="@a/close.png" @click="show=false"/></h2>
      <div class="lading_main">
        <div class="login-input">
          <img src="@a/tel.png" />
          <input type="number" v-model="phone" onkeydown="if(event.keyCode==13) return false" placeholder="填写手机号">
        </div>
        <div v-if="need_verify" class="login-input">
          <img src="@a/code.png" />
          <input type="number" onkeydown="if(event.keyCode==13) return false" v-model="code" placeholder="请填写验证码，共4位">
          <button :class="{ activeBu: buttacti,disabled:!canClick}" @click="verification_code">{{verification_code_text}}</button>
        </div>
        <div class="landing_href active" v-if="need_verify && phone && code" @click="validationHandle">
          下一步
        </div>
        <div class="landing_href active" v-else-if="!need_verify && phone" @click="phoneHandle">
          下一步
        </div>
        <div class="landing_href" v-else>
          下一步
        </div>
      </div>
    </van-popup>
    <!-- 报名课程时间冲突 -->
    <van-popup class="pub_alert" v-model="conTimeBool">
      <div class="confirm_box">
        <h2>您好，您之前报名的（<span v-for="(item,index) in intersect" :key="index">{{item.bigcourse+item.course}}</span><span v-if="index<intersect.length-1">、</span>）上课时间和您现在报名的课程上课时间有冲突，建议您选择不冲突的时间进行报名！</h2>
        <div class="btn_group">
          <a class="confirm on" href="javascript:;" @click="goPay()">继续报名</a>
          <a class="cancel" href="javascript:;" @click="conTimeBool=false">取消</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  mc_buyCourse
} from "@/api/person"
import {
  stat_verify_mobile
} from "@/api/course"
import {
  save_no_verify_mobile
} from "@/api/course"
import {
  sendmsg
} from "@/api/course"
import {
  subcode,
  paySuccess
} from "@/api/course"
import {
  phoneValidation
} from "@/utils/validation"
import {
  events
} from "@/utils/validation"
import {
  buycourse,
  wxpay,
  createOrder,
  buyCourseOffers,
  activity_order,
  scrabbleBuy
} from "@/api/pay"
import wx from "weixin-js-sdk"
export default {
  data() {
      return {
        verification_code_text: '发送验证码',
        totalTime: 60,
        canClick: true,
        buttacti: false,
        code: '',
        show: false,
        need_verify: false,
        phone: null,
        // 报名课程时间冲突
        payData:{},
        conTimeBool:false,
        intersect:[]
      }
    },
    props: {
      cid: {
        default: null
      },
      type: {
        type: String,
        default: ''
      },
      source: {
        type: String,
        default: ''
      },
      pdk: {
        type: String,
        default: ''
      },
      aspx: {
        type: String,
        default: ''
      },
      teacherid: {
        default: null
      },
      id: {
        default: null
      },
      use_id: {
        default: ''
      },
      sharetype: {
        default: ''
      },
      train_pay: {
        default: {}
      },
      orderObj: {
        default: {}
      },
      orientation_pay: {
        default: {}
      },
      orientation_pay: {
        default: {}
      },
      scrabble: {
        default: {}
      }
    },
    methods: {
      // 验证码
      verification_code() {
        //统计手机验证
        stat_verify_mobile({
            cid: this.cid,
          })
          .then();
        if (phoneValidation(this.phone)) {
          // 请求验证码
          sendmsg({
              tel: this.phone,
              type: this.type,
              campaignName: this.source instanceof Array ? this.source[0] : this.source || '',
              courseID: this.cid,
            })
            .then((data) => {
              // 验证手机号是否正确
              events(this.verification_code_text, this.totalTime, this.canClick, (verification_code_text, totalTime, canClick) => {
                this.verification_code_text = verification_code_text;
                this.totalTime = totalTime;
                this.canClick = canClick;
              });
            });
        } else {
          // 手机号验证不正确提示
          this.$toast('您输入的手机号不正确！/(ㄒoㄒ)/~~');
        }
      },
      shec() {
        // 神策统计--未验证手机号
        sensors.track('verifyMobile', {
          user_mobile: this.phone
        });
      },
      // 验证手机号和验证码
      validationHandle() {
        // this.shec();
        subcode({
            tel: this.phone,
            code: this.code,
            campaignName: this.source instanceof Array ? this.source[0] : this.source || '',
            courseID: this.cid,
          })
          .then((data) => {
            this.show = false;
            if (this.type == "coach") {
              this.pay_tor()
            } else {
              this.pay();
            }

          });
      },
      // 只验证手机号
      phoneHandle() {
        // this.shec();
        if (phoneValidation(this.phone)) {
          this.$emit("statistic_");
          save_no_verify_mobile({
              mobile: this.phone,
              campaignName: this.source instanceof Array ? this.source[0] : this.source || '',
              cid: this.cid,
            })
            .then((data) => {
              this.show = false;
              if (this.type == "coach") {
                this.pay_tor()
              } else {
                this.pay();
              }
            });
        } else {
          // 手机号验证不正确提示
          this.$toast('您输入的手机号不正确！/(ㄒoㄒ)/~~');
        }
      },
      // 支付
      pay() {
        this.$toast({
          type: 'loading',
          duration: 0,
          mask: true,
          message: '加载中...'
        });
        buycourse({
            pdk: this.pdk || '', //用户统计被分享出去链接被点击
            aspx: this.aspx || '',
            source: this.source instanceof Array ? this.source[0] : this.source || '',
            cid: this.cid,
            use_id: this.use_id,
            sharetype: this.sharetype
          })
          .then((data) => {
            this.$toast.clear();
            if (typeof data.data === "string") {
              this.$toast.clear();
              this.$toast(data.data);
            } else {
              this.payData = data;
              if(data.intersect && data.intersect.length>0){
                this.intersect = data.intersect;
                this.conTimeBool=true;
              }else{
                this.goPay();
              }
              
            }

          });
      },
      // 继续课程支付
      goPay(){
        let data_ = eval('(' + this.payData.jsApiParameters + ')');

        let jsApiCall = () => {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', data_, (rest) => {
              WeixinJSBridge.log(rest.err_msg);
              (rest.err_msg);
              if (rest.err_msg == "get_brand_wcpay_request:ok") {
                this.$router.push({
                  path: '/buy_success',
                  query: {
                    pay: 'ok',
                    cid: this.cid
                  }
                })
              } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                // alert("支付取消")
                this.$router.push({
                  path: '/my_course_details',
                  query: {
                    id: data.id
                  }
                })
              } else {
                // alert("支付失败");
                this.$router.push({
                  path: '/my_course_details',
                  query: {
                    id: data.id
                  }
                })
              }
            }
          );
        };

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', jsApiCall);
            document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        } else {
          jsApiCall();
        }
      },
      // 辅导支付
      pay_tor() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        wxpay({
            teacherid: this.teacherid
          })
          .then((data) => {
            // if(typeof data === "string"){
            //   let index = data.lastIndexOf('/');
            //   let last = data.lastIndexOf('.');
            //   let x = data.substring(index, last);
            //   this.$router.push({
            //     path:x
            //   });
            // }else{
            if (typeof data.data === "string") {
              this.$toast.clear();
              this.$toast(data.data);
            } else {
              let data_ = eval('(' + data + ')');
              let jsApiCall = () => {
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', data_, (rest) => {
                    this.$toast.clear();
                    WeixinJSBridge.log(rest.err_msg);
                    alert(rest.err_msg)
                    if (rest.err_msg == "get_brand_wcpay_request:ok") {
                      this.$router.push({
                        path: '/totoring_buy_success',
                        query: {
                          pay: 'ok'
                        }
                      })
                    } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                      alert("支付取消")
                    } else {
                      alert("支付失败")
                    }
                  }
                );
              };

              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', jsApiCall);
                  document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
                }
              } else {
                jsApiCall();
              }
            }
          });
      },
      // 支付订单
      pay_order() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        mc_buyCourse({
            pdk: this.pdk || '', //用户统计被分享出去链接被点击
            aspx: this.aspx || '',
            source: this.source instanceof Array ? this.source[0] : this.source || '',
            id: this.id,
            cid: this.cid
          })
          .then((data) => {
            let data_ = eval('(' + data + ')');
            let jsApiCall = () => {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', data_, (rest) => {
                  this.$toast.clear();
                  WeixinJSBridge.log(rest.err_msg);
                  if (rest.err_msg == "get_brand_wcpay_request:ok") {
                    this.$emit('refiers');
                  } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                    alert("支付取消")
                  } else {
                    this.$emit('refiers');
                    alert("支付失败")
                  }
                }
              );
            };

            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', jsApiCall);
                document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
              }
            } else {
              jsApiCall();
            }
          });
      },
      // 联报支付
      pay_quote() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        buyCourseOffers(this.orderObj)
          .then((data) => {
            let data_ = eval('(' + data.jsApiParameters + ')');
            let jsApiCall = () => {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', data_, (rest) => {
                  this.$toast.clear();
                  WeixinJSBridge.log(rest.err_msg);
                  if (rest.err_msg == "get_brand_wcpay_request:ok") {
                    this.$router.push('/my_course')
                  } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                    alert("支付取消")
                  } else {
                    this.$emit('refiers');
                    alert("支付失败")
                  }
                }
              );
            };

            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', jsApiCall);
                document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
              }
            } else {
              jsApiCall();
            }
          });
      },
      // 7天训练营支付
      pay_training() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        createOrder(this.train_pay)
          .then((data) => {

            if (typeof data.data === "string") {
              this.$toast.clear();
              this.$toast(data.data);
            } else {
              let data_ = eval('(' + data.jsApiParameters + ')');

              let jsApiCall = () => {
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', data_, (rest) => {
                    WeixinJSBridge.log(rest.err_msg);
                    (rest.err_msg);
                    if (rest.err_msg == "get_brand_wcpay_request:ok") {
                      if (this.train_pay.mission_type == 1) {
                        this.$emit('refiers');
                      } else {
                        this.$router.push({
                          path: '/teacher_code',
                          query: {
                            course_id: this.train_pay.course_id
                          }
                        })
                      }

                    } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                      alert("支付取消")
                    } else {
                      alert("支付失败");
                    }
                  }
                );
              };

              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', jsApiCall);
                  document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
                }
              } else {
                jsApiCall();
              }

            }

          });
      },
      // 拼团功能支付
      pay_spell() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        scrabbleBuy(this.scrabble)
          .then((data) => {

            if (typeof data.data === "string") {
              this.$toast.clear();
              this.$toast(data.data);
            } else {
              let data_ = eval('(' + data.jsApiParameters + ')');

              let jsApiCall = () => {
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', data_, (rest) => {
                    WeixinJSBridge.log(rest.err_msg);
                    (rest.err_msg);
                    if (rest.err_msg == "get_brand_wcpay_request:ok") {
                      paySuccess({
                          cid: this.scrabble.cid,
                          scrabble_id: data.id
                        })
                        .then((datas) => {
                          if (datas.joinStatus) {
                            this.$router.push({
                              path: '/buy_success',
                              query: {
                                cid: this.scrabble.cid
                              }
                            })

                          } else {
                            this.$router.push({
                              path: '/course_spell',
                              query: {
                                scrabble_type: 'invite',
                                scrabble_id: data.id
                              }
                            })
                            this.$emit('refiers');
                          }
                        })

                    } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                      alert("支付取消");
                    } else {
                      alert("支付失败");

                    }
                  }
                );
              };

              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', jsApiCall);
                  document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
                }
              } else {
                jsApiCall();
              }

            }

          });
      },
      /*
       *@Description: 7天职业定位特训营
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-12 14:37:59
       */
      pay_orientation() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        activity_order(this.orientation_pay).then((data) => {
          let data_ = eval('(' + data.jsApiParameters + ')');
          let jsApiCall = () => {
            WeixinJSBridge.invoke(
              'getBrandWCPayRequest', data_, (rest) => {
                this.$toast.clear();
                WeixinJSBridge.log(rest.err_msg);
                if (rest.err_msg == "get_brand_wcpay_request:ok") {
                  this.$router.push({
                    path: '/teacher_code',
                    query: {
                      course_id: this.orientation_pay.course_id
                    }
                  })
                } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                  alert("支付取消")
                } else {
                  this.$emit('refiers');
                  alert("支付失败")
                }
              }
            );
          };

          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', jsApiCall);
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
            }
          } else {
            jsApiCall();
          }
        });
      }
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
// 手机验证
.phone_pop {
  height: changeRem(9.64)+px;
  text-align: center;
  h2 {
    line-height: changeRem(2)+px;
    border-bottom: 1px solid #ccc;
    position: relative;
    color: #333;
    font-size: changeRem(.68)+px;
    img {
      position: absolute;
      width: changeRem(.48)+px;
      height: changeRem(.48)+px;
      top: changeRem(.76)+px;
      right: changeRem(.6)+px;
    }
  }
}

.disabled {
  cursor: not-allowed; // 鼠标变化
  opacity: .6;
}

.lading_main {
  width: changeRem(11.56)+px;
  margin: 0 auto;
  margin-top: changeRem(.44)+px;
  .login-input {
    width: 100%;
    border-bottom: 1px solid #ccc;
    height: changeRem(1.8)+px;
    line-height: changeRem(1.8)+px;
    text-align: left;
    img {
      width: changeRem(.8)+px;
      height: changeRem(.8)+px;
      vertical-align: middle;
    }
    input {
      padding: 0 changeRem(.36)+px;
      font-size: changeRem(.64)+px;
      color: #333;
      height: changeRem(.8)+px;
      line-height: changeRem(.8)+px;
      width: changeRem(7)+px;
      border: none;
      margin-bottom: 0;
    }
    button {
      width: changeRem(2.92)+px;
      // height: changeRem(.96)+px;
      border: 1px solid rgba(235, 80, 50, 1);
      border-radius: changeRem(.04)+px;
      line-height: changeRem(.96)+px;
      color: #EB5032;
      font-size: changeRem(.48)+px;
      text-align: center;
      float: right;
      margin-right: changeRem(.2)+px;
      padding: 0;
      margin: 0;
      margin-top: changeRem(.4)+px;
      background-color: transparent;
      box-sizing: content-box;
    }
  }
  .landing_href {
    width: 100%;
    height: changeRem(1.6)+px;
    background: #BABABA;
    border-radius: changeRem(.16)+px;
    line-height: changeRem(1.6)+px;
    text-align: center;
    font-size: changeRem(.68)+px;
    color: #fff;
    margin-top: changeRem(1.06)+px;
  }
  .landing_href.active {
    background-color: #EB5032;
  }
}
.confirm_box{
  width:576px;
}
</style>
